(function (global, factory) {
    typeof exports === "object" && typeof module !== "undefined" ? module.exports = factory() : (global.pwaInstallPrompt = factory());
}(this, (function () {
    return (func, args = [], element = document) => {
        const IFRAMES = element.getElementsByTagName("iframe");

        for (let i = 0; i < IFRAMES.length; ++i) {
            if (IFRAMES[i]) {
                const SRC = IFRAMES[i].getAttribute("src");

                if (SRC && SRC.toLowerCase().indexOf("youtube.com/embed") !== -1) {
                    IFRAMES[i].contentWindow.postMessage(JSON.stringify({
                        "args": args, // eslint-disable-line
                        "event": "command",
                        "func": func // eslint-disable-line
                    }), "*");
                }
            }
        }
    };
})));
